'use strict';

var $    					= require('jquery');
var Core 					= require('../core/core.js');
var InspectorColorSwatch = require('./inspector__colorpicker__swatch.js');

/**
 * Creates an colorswatch div. made to be used inside the inspector.
 * make sure to populate with color items
 *
 * @class
 */

class InspectorColorPickerMulticolor extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
      <div class="editor__inspector__colorpicker__multicolor">
        <div class="editor__inspector__colorpicker__multicolor__btn js-inspector__multicolor__btn">
          <canvas class="editor__inspector__colorpicker__multicolor__canvas js-inspector__multicolor__canvas" />
        </div>
        <div class="editor__inspector__colorpicker__multicolor__label">
          Multicolor
        </div>
        <div class="editor__inspector__colorpicker__multicolor__disclaimer">
          Preserve object colors when grouped
        </div>
      </div>
		`;

		super.render();

    $(this.$el).on('click', this._toggleMulticolor);

    //default mode
    this.drawDeselected();
	}

  drawDeselected() {
    var canvas = $('.js-inspector__multicolor__canvas', this.$el).get(0);
    var ctx = canvas.getContext("2d");
    var sections = 8;
    var rectWidth = canvas.width/sections;

    for (var i=0; i < sections; i++) {
      if (i%2) {
        ctx.fillStyle = "#aaaaaa";
      } else {
        ctx.fillStyle = "#cccccc";
      }
      ctx.fillRect(rectWidth*i,0,rectWidth*i + rectWidth, canvas.height*2);
    }
  }

  drawSelectedColors(colorList) {
    var canvas = $('.js-inspector__multicolor__canvas', this.$el).get(0);
    var ctx = canvas.getContext("2d");
    var sections = 8;
    var rectWidth = canvas.width/sections;
    for (var i=0; i < sections; i++) {
      ctx.fillStyle = colorList[i%colorList.length];
      ctx.fillRect(rectWidth*i,0,rectWidth*i + rectWidth, canvas.height*2);
    }
  }

  _toggleMulticolor(e) {
    e.preventDefault();
		$(e.currentTarget).trigger('Cioui:Inspector:click', e);

    //toggle selected class from any other swatch then add to target
    $('.js-inspector__multicolor__btn').toggleClass('editor__inspector__colorswatch--selected');
  }

}
module.exports = InspectorColorPickerMulticolor;
